import React from 'react';
import PageSection from '../components/PageSection';
import InfoList from '../components/InfoList';
import IconBulletList from '../components/IconBulletList';
import StatCard from '../components/StatCard';

const clients = [
  {
    label: 'Generali Assicurazioni',
    description: 'Soluzioni sinistri e portali partner',
    icon: '🏦'
  },
  {
    label: 'CiaoAmigos',
    description: 'Community e app di engagement',
    icon: '💬'
  },
  {
    label: 'Electronic Arts',
    description: 'Esports platform e analytics live',
    icon: '🎮'
  },
  {
    label: 'McKinsey & Company',
    description: 'Dashboard strategiche e knowledge management',
    icon: '📈'
  },
  {
    label: 'AWS (Amazon Web Services)',
    description: 'Programmi partner e workload cloud-native',
    icon: '☁️'
  },
  {
    label: 'Samsung',
    description: 'Soluzioni retail e tecnologie per il field',
    icon: '📱'
  }
];

const sectors = [
  { label: 'Commercio', description: 'E-commerce e retail tech', icon: '🛒' },
  { label: 'Industria', description: 'MES, IoT e supply chain', icon: '🏭' },
  { label: 'Finanza', description: 'Fintech e integrazioni core', icon: '💳' },
  { label: 'Servizi', description: 'Portali clienti e CRM', icon: '🧩' },
  { label: 'Sport', description: 'Fan experience e big data', icon: '🥇' }
];

const stats = [
  {
    value: '25+',
    label: 'professionisti',
    description: 'Team multidisciplinare con focus full-stack e UX'
  },
  {
    value: '300+',
    label: 'progetti consegnati',
    description: 'Dalla prototipazione al go-live per scale-up e enterprise'
  },
  {
    value: '96%',
    label: 'clienti soddisfatti',
    description: 'Misurato su survey annuale e NPS interno'
  }
];

const ChiSiamo = () => {
  return (
    <>
      <section className="hero hero-secondary">
        <div className="container hero-inner small">
          <p className="eyebrow">Chi siamo</p>
          <h1>HelpSoftware è un’azienda di sviluppo software attiva dal 1998.</h1>
          <p className="hero-subtitle">
            Realizziamo soluzioni digitali su misura, affidabili, sicure e
            scalabili. Lavoriamo al fianco dei clienti con team snelli,
            metodologia agile e standard di qualità certificati.
          </p>
        </div>
      </section>

      <PageSection
        title="Numeri e metodo"
        intro="Investiamo in discovery, design operativo e sviluppo iterativo per portare valore misurabile in ogni sprint."
      >
        <div className="stat-grid">
          {stats.map(stat => (
            <StatCard key={stat.label} {...stat} />
          ))}
        </div>
      </PageSection>

      <PageSection title="Clienti e settori">
        <div className="info-grid">
          <IconBulletList title="Clienti principali" items={clients} />
          <IconBulletList title="Settori" items={sectors} />
        </div>
      </PageSection>

      <PageSection title="Mission">
        <p className="mission-text">
          La nostra missione è creare software di qualità, progettato sulle reali
          esigenze del cliente, con un approccio consulenziale e proattivo. Ogni
          progetto combina strategia, tecnologia e cura del dettaglio per
          garantire continuità operativa e crescita sul lungo periodo.
        </p>

        <InfoList
          title="Come lavoriamo"
          items={[
            'Workshop di co-design e roadmap di valore condivisa',
            'Architetture cloud-native e integrazione dei sistemi legacy',
            'Misurazione continua di KPI e supporto post go-live',
            'Sviluppo di app mobile con stack React Native e Flutter'
          ]}
        />
      </PageSection>
    </>
  );
};

export default ChiSiamo;
